// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--f9a37";
export var bottomList = "style-module--bottom-list--a05b9";
export var info = "style-module--info--f09c8";
export var num = "style-module--num--d1384";
export var text = "style-module--text--2dcb9";
export var top = "style-module--top--dcbd9";
export var topList = "style-module--top-list--77497";
export var vid = "style-module--vid--66a0b";